import React from 'react';
import { ReactTyped } from 'react-typed';
import { useTranslation } from 'react-i18next';
import '../../components/css/Main.css';

function LandingPage() {
  const { t, i18n } = useTranslation();
  // key forces ReactTyped to re-mount when language changes
  const typedKey = i18n.language;

  return (
    <div className="main-container" style={{ fontFamily: "Prompt, sans-serif" }}>
      <h1 className="main-heading">
        {t('home.hero.headingPrefix')}
        <span className="animated-underline">
          <ReactTyped
            key={typedKey}
            strings={[
              t('home.hero.typed1'),
              t('home.hero.typed2'),
              t('home.hero.typed3'),
            ]}
            typeSpeed={80}
            backSpeed={50}
            backDelay={2000}
            loop
          />
        </span>
      </h1>
      <p className="main-paragraph">
        {t('home.hero.paragraph')}
      </p>
    </div>
  );
}

export default LandingPage;
